module.exports = __webpack_public_path__ + "img/car-1.a78e6e39.jpg";